import { memo } from 'react';

import isEqual from 'lodash/isEqual';

import { Skeleton } from '@/components/Skeleton';

type TProps = {
  className?: string;
  withSkeleton?: boolean;
};

const UpliftReceiver = memo(({ className, withSkeleton }: TProps) => {
  return (
    <span className={className} data-up-from-currency-unit-major="">
      {withSkeleton && <Skeleton inline width="20px" />}
    </span>
  );
}, isEqual);

UpliftReceiver.displayName = 'UpliftReceiver';

export default UpliftReceiver;
